import Vue from 'vue'
import socialMediaPostApi from '@/api/socialMediaPost.api'

const state = {
  socialMediaPosts: {},
  socialMediaPostsLoadedByProject: {}
}


const getters = {
  socialMediaPostById: (state, getters) => (id) => {
    return getters.socialMediaPosts.find(x => x.id === id)
  },

  socialMediaPostsByProject: (state, getters) => (projectId) => {
    return getters.socialMediaPosts.filter(x => x.projectId === projectId)
  },

  socialMediaPosts: (state, getters, rootState, rootGetters) => {
    return Object.values(state.socialMediaPosts).map(post => {
      const mappedPost = { ...post }
      mappedPost.channels = post.channels.map(channel => {
        return {
          ...channel,
          ...rootGetters['socialMediaChannel/socialMediaChannelById'](channel.channelId)
        }
      })

      return mappedPost
    })
  },

  socialMediaPostsLoadedByProject: (state) => (projectId) => {
    return state.socialMediaPostsLoadedByProject[projectId] === true
  }
}


const actions = {
  async loadSocialMediaPost ({ commit, rootState }, { projectId, id }) {
    const response = await socialMediaPostApi.getSocialMediaPost(rootState.tenant.current, projectId, id)
    commit('UPDATE_SOCIAL_MEDIA_POST', response.data)
    return response.data
  },

  // async loadPostByPostData ({ commit, rootState }, postData) {
  //   const response = await socialMediaPostApi.getSocialMediaPost(rootState.tenant.current, postData.projectId, postData.id)
  //   commit('UPDATE_SOCIAL_MEDIA_POST', response.data)
  //   return response.data
  // },
  //
  // async updatePostByPostData ({ commit, rootState }, postData) {
  //   commit('UPDATE_SOCIAL_MEDIA_POST', postData)
  // },

  async loadAndUpdatePost ({ commit, rootState }, entityData) {
    const response = await socialMediaPostApi.getSocialMediaPost(rootState.tenant.current, entityData.projectId, entityData.entityId)
    commit('UPDATE_SOCIAL_MEDIA_POST', response.data)
    return response.data
  },

  async loadSocialMediaPostsByProject ({ commit, rootState }, projectId) {
    const response = await socialMediaPostApi.getSocialMediaPosts(rootState.tenant.current, projectId)
    commit('SET_SOCIAL_MEDIA_POSTS', response.data)
    commit('SET_SOCIAL_MEDIA_POSTS_LOADED_BY_PROJECT', projectId)
  },

  async createSocialMediaPost ({ commit, rootState }, socialMediaPost) {
    const projectId = socialMediaPost.projectId
    const response = await socialMediaPostApi.createSocialMediaPost(rootState.tenant.current, projectId, socialMediaPost)
    commit('CREATE_SOCIAL_MEDIA_POST', response.data)
    return response.data
  },

  async updateSocialMediaPost ({ commit, rootState }, socialMediaPost) {
    const projectId = socialMediaPost.projectId
    const response = await socialMediaPostApi.updateSocialMediaPost(rootState.tenant.current, projectId, socialMediaPost.id, socialMediaPost)
    commit('UPDATE_SOCIAL_MEDIA_POST', response.data)
    return response.data
  },

  async publishSocialMediaPost ({ commit, rootState }, { projectId, id }) {
    const response = await socialMediaPostApi.publishSocialMediaPost(rootState.tenant.current, projectId, id)
    commit('UPDATE_SOCIAL_MEDIA_POST', response.data)
    return response.data
  },

  async deleteSocialMediaPost ({ commit, rootState }, { id, projectId }) {
    await socialMediaPostApi.deleteSocialMediaPost(rootState.tenant.current, projectId, id)
    commit('DELETE_SOCIAL_MEDIA_POST', id)
  }
}


const mutations = {
  SET_SOCIAL_MEDIA_POSTS (state, socialMediaPosts) {
    state.socialMediaPosts = {}
    for (const socialMediaPost of socialMediaPosts) {
      Vue.set(state.socialMediaPosts, socialMediaPost.id, socialMediaPost)
    }
  },

  SET_SOCIAL_MEDIA_POSTS_LOADED_BY_PROJECT (state, projectId) {
    Vue.set(state.socialMediaPostsLoadedByProject, projectId, true)
  },

  CREATE_SOCIAL_MEDIA_POST (state, socialMediaPost) {
    Vue.set(state.socialMediaPosts, socialMediaPost.id, socialMediaPost)
  },

  UPDATE_SOCIAL_MEDIA_POST (state, socialMediaPost) {
    Vue.set(state.socialMediaPosts, socialMediaPost.id, socialMediaPost)
  },

  DELETE_SOCIAL_MEDIA_POST (state, id) {
    Vue.delete(state.socialMediaPosts, id)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
